export default __webpack_public_path__ + "static/vatan-logo-6a56abd6fa2be921a80e6906f01cb06d.svg";